import { render } from "./CollectionOrganisationInviteListView.vue?vue&type=template&id=b9ed0bde"
import script from "./CollectionOrganisationInviteListView.vue?vue&type=script&lang=js"
export * from "./CollectionOrganisationInviteListView.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__